import { render } from "./chevron.svg?vue&type=template&id=249c637a?inline"
const script = {}
script.render = render

export default script